<template>
<van-tabbar class="tabbar-div" @change="changeFn" v-model="active" active-color="#ee0a24">
  <van-tabbar-item v-if="active !== 0" :icon="'wap-home-o'">Home</van-tabbar-item>
  <van-tabbar-item v-else :icon="active === 0 ? 'wap-home' : 'wap-home-o'">
    <span>Home</span>
    <template #icon>
      <img class="home-icon" v-webp src="https://image.kilimall.com/kenya/new_wap/logo/icon_48.png" />
    </template>
  </van-tabbar-item>
  <van-tabbar-item :icon="active === 1 ? 'bars' : 'bars'">Categories</van-tabbar-item>
  <van-tabbar-item :icon="active === 2 ? 'chat' : 'chat-o'">Message</van-tabbar-item>
  <van-tabbar-item>
    <van-badge 
      :content="useShopingCartTotal().value"
      style="margin-bottom: 2px;"
      :show-zero="false"
    >
      <van-icon class="cart-icon" :name="active === 3 ? 'cart' : 'cart-o'" />
      <div>Cart</div>
    </van-badge>
  </van-tabbar-item>
  <van-tabbar-item>
    <div class="account-div">
      <van-icon class="cart-icon" :name="active === 4 ? 'manager' : 'contact'" />
      <div>Account</div>
      <div v-if="isDot" class="badge-dot-div"></div>
    </div>
  </van-tabbar-item>
</van-tabbar>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const active = ref(0)
const route = useRoute()
const router = useRouter()
watch(
  () => route.name ,
  (val) => {
    switch (val) {
      case 'home': 
        active.value = 0
        break
      case 'all-category': 
        active.value = 1
        break
      case 'shopping-cart': 
        active.value = 3
        break
      case 'user-center': 
        active.value = 4
        break
      case 'message':
        active.value = 2
        break
      default: break
    }
  },
  { immediate: true }
)
const isDot = computed(() => {
  if (useUserInfo().value?.accessToken && (!useUserInfo().value?.email || !useUserInfo().value?.phone)
    && window && !localStorage.getItem('wap_user_info_dot')) {
    // 已登录， 并且手机号或邮箱存在未填写的情况， 并且未点击过红点区域， 显示红点
    return true
  }
  return false
})
const changeFn = (index: number) => {
  switch (index) {
    case 0: 
      router.push('/')
      break
    case 1: 
      router.push('/all-category')
      break
    case 2:
      router.push('/message')
      break
    case 3: 
      router.push('/shopping-cart')
      break
    case 4: 
      router.push('/user-center')
      // 点击了红点区域， 记录已点击
      if (isDot.value) {
        localStorage.setItem('wap_user_info_dot', '1')
      }
      break
    default: break
  }
}

</script>
<style lang='scss' scoped>
.tabbar-div {
  position: fixed;
  bottom: 0;
  left: 0;
  .home-icon {
    border-radius: 4px;
  }
}
.cart-icon{
  font-size: 52px;
}
.account-div {
  text-align: center;
  .badge-dot-div {
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: red;
    border-radius: 20px;
    right: 28px;
    top: 8px;
  }
}
</style>